import localStorage from 'local-storage'
import { constants } from 'helpers'

import mixpanel from './mixpanel'
import snowplow from './snowplow'


const pageEventSessionTime = 30 * 60 * 1000 // 30 minutes

const isPageEventSessionActive = () => {
  const nowTime = Date.now()
  const lastPageEventTime = localStorage.getItem<number>(constants.localStorageNames.lastAnalyticsPageEventTime)
  const timeDiff = lastPageEventTime ? nowTime - lastPageEventTime : 0

  return !lastPageEventTime || timeDiff > pageEventSessionTime
}

const updatePageEventSessionActivity = () => {
  localStorage.setItem(constants.localStorageNames.lastAnalyticsPageEventTime, Date.now())
}

export const track: Analytics.TrackFunction<Analytics.Events> = (...args) => {
  const [ eventName, ...trackArgs ] = args
  const isPageEvent = /\spage$/.test(eventName)

  if (isPageEvent) {
    const isEntryPoint = isPageEventSessionActive()

    if (isEntryPoint) {
      trackArgs[0] = {
        ...trackArgs[0],
        isEntryPoint: true,
      }
    }

    updatePageEventSessionActivity()
  }

  mixpanel.track(eventName, ...trackArgs)
  snowplow.track(eventName, ...trackArgs)
}

export * from './context'
export { default as mixpanel } from './mixpanel'
export { default as snowplow } from './snowplow'
export { default as dataLayer } from './dataLayer'
